import * as urls from "./url";
import client, { getHeader } from "../client";
import { interceptor, substituteEncrypted } from "../../util/util";

//My Profile.js

export const getPrimaryAccountDetailsCall = async (reqBody) =>
  interceptor(async () => client.post(urls.getPrimaryAccountDetails, await substituteEncrypted(reqBody), getHeader()));

export const patchEditPhoneEmailCall = async (postData) =>
  interceptor(async () => client.post(urls.patchEditPhoneEmail, await substituteEncrypted(postData), getHeader()));

export const patchBillingAddressCall = async (postData) =>
  interceptor(async () => client.post(urls.patchBillingAddress, await substituteEncrypted(postData), getHeader()));

//PrimaryAccount.js

export const getAccountContactCall = async (reqBody) =>
  interceptor(async () => client.post(urls.getAccountContact, await substituteEncrypted(reqBody), getHeader()));

export const getAccountContactDetailsCall = async (reqBody) =>
  interceptor(async () => client.post(urls.getAccountContactDetails, await substituteEncrypted(reqBody), getHeader()));

export const postNewContactCall = async (postData) =>
  interceptor(async () => client.post(urls.postNewContact, await substituteEncrypted(postData), getHeader()));

export const patchExistingContactCall = async (postData) =>
  interceptor(async () => client.post(urls.patchExistingContact, await substituteEncrypted(postData), getHeader()));

export const deleteContactCall = async (accountId) => interceptor(async () => client.delete(urls.deleteContact + accountId, getHeader()));

export const patchAccountContactsInvoiceCall = async (patchData) =>
  interceptor(async () => client.post(urls.patchAccountContactsInvoice, await substituteEncrypted(patchData), getHeader()));
//ContractAccount.js

export const getContractAccountCall = async (reqBody) =>
  interceptor(async () => client.post(urls.getContractAccount, await substituteEncrypted(reqBody), getHeader()));

export const getContractInvoicePreferenceCall = async (reqBody) =>
  interceptor(async () => client.post(urls.getContractInvoicePreference, await substituteEncrypted(reqBody), getHeader()));

export const patchContractInvoicePreferenceCall = async (postData) =>
  interceptor(async () => client.post(urls.patchContractInvoicePreference, await substituteEncrypted(postData), getHeader()));

export const getValidateContractApiCall = async (accountNumber, contractNumber, userId) =>
  interceptor(async () =>
    client.post(
      urls.getValidateContractUrl(),
      await substituteEncrypted({
        accountNo: accountNumber,
        contractNumber: contractNumber,
        userId: userId,
      }),
      getHeader()
    )
  );

export const getContractNumbersApiCall = async (contractNumbersPostData) =>
  interceptor(async () => client.post(urls.getContractNumbersUrl(), await substituteEncrypted(contractNumbersPostData), getHeader()));
//START - REDBALL CONFIG
export const getPaymentStatusApiCall = async (reqBody) =>
  interceptor(async () => client.post(urls.getPaymentStatusUrl, await substituteEncrypted(reqBody, "getPaymentStatusApiCall"), getHeader()));
//END - REDBALL CONFIG
// Manage Invoice Preference

export const fetchInvoicePreference = async (reqBody) =>
  interceptor(async () => client.post(urls.fetchInvoicePreference, await substituteEncrypted(reqBody), getHeader()));
export const createNewContact = async (reqBody) =>
  interceptor(async () => client.post(urls.createNewContact, await substituteEncrypted(reqBody), getHeader()));
export const updateInvoicePreference = async (reqBody) =>
  interceptor(async () => client.post(urls.updateInvoicePreference, await substituteEncrypted(reqBody), getHeader()));

// autoPayCheck
export const autoPayCheckCall = async (reqBody) =>
  interceptor(async () => client.post(urls.autoPayCheck, await substituteEncrypted(reqBody), getHeader()));

export const updatePaymentStatusCall = async (reqBody) => interceptor(async () => client.post(urls.updatePaymentStatus(), reqBody, getHeader()));
